import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import AdminLayout from './AdminLayout';

// Section pages - each imported from its dedicated module
import MembersPage from './admin/MembersPage';
import EventsPage from './admin/EventsPage';
import EmailPage from './admin/EmailPage';
import EmailTemplatesPage from './admin/EmailTemplatesPage';
import BlogsPage from './admin/BlogsPage';
import CommentsPage from './admin/CommentsPage';
import GalleryPage from './admin/GalleryPage';
import LecturesPage from './admin/LecturesPage';
import DistributionListsPage from './admin/DistributionListsPage';
import NavaratriAdminPage from './admin/NavaratriAdminPage';

// Shared admin menu items - used by AdminLayout and App.js
export const ADMIN_MENU_ITEMS = [
  { to: '/admin/members', label: 'Manage Members', icon: 'fa-users' },
  { to: '/admin/events', label: 'Manage Events', icon: 'fa-calendar-plus' },
  { to: '/admin/email', label: 'Send Emails', icon: 'fa-envelope' },
  { to: '/admin/email-templates', label: 'Manage Email Templates', icon: 'fa-file-lines' },
  { to: '/admin/blogs', label: 'Review Blogs', icon: 'fa-blog' },
  { to: '/admin/comments', label: 'Review Comments', icon: 'fa-comments' },
  { to: '/admin/gallery', label: 'Gallery Uploads', icon: 'fa-images' },
  { to: '/admin/lectures', label: 'Lecture Uploads', icon: 'fa-film' },
  { to: '/admin/distribution-lists', label: 'Manage DLs', icon: 'fa-list' },
  { to: '/admin/navaratri', label: 'Navaratri Bookings', icon: 'fa-calendar-check' },
];

export default function AdminPage() {
  return (
    <Routes>
      <Route element={<AdminLayout />}>
        <Route index element={<Navigate to="/admin/members" replace />} />
        <Route path="members" element={<MembersPage />} />
        <Route path="events" element={<EventsPage />} />
        <Route path="email" element={<EmailPage />} />
        <Route path="email-templates" element={<EmailTemplatesPage />} />
        <Route path="blogs" element={<BlogsPage />} />
        <Route path="comments" element={<CommentsPage />} />
        <Route path="gallery" element={<GalleryPage />} />
        <Route path="lectures" element={<LecturesPage />} />
        <Route path="distribution-lists" element={<DistributionListsPage />} />
        <Route path="navaratri" element={<NavaratriAdminPage />} />
      </Route>
    </Routes>
  );
}